import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor() { }

  // 랜덤한 doc 아이디 만들기
  generateFilename() {
    let length = 10;
    let text = '';
    let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text + new Date().valueOf();
  }


  /**
   * 파이어베이스 스토리지 url인지 확인하는 함수
   * @param url 
   */
  checkStorageUrl(url: string) {
    const splitUrl = url.split(':')[0]
    return splitUrl === 'https'
  }

}